import { Pencil, Trash2, FileText as FileTextIcon } from "lucide-react";
import { JobReportMenu } from "./JobReportMenu";

export const OrderRow = ({ order: o, canWrite, canDelete, openEdit, onDelete, downloadJobReport }) => (
  <tr
    data-testid={`order-row-${o.id}`}
    onDoubleClick={() => canWrite && openEdit(o)}
    onClick={() => {
      if (canWrite && typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches) {
        openEdit(o);
      }
    }}
    title={canWrite ? "Double-click to edit (tap on mobile)" : undefined}
    className={`border-t border-[#33424f]/10 hover:bg-[#f5f1ec] ${canWrite ? "cursor-pointer select-none" : ""}`}
  >
    <td className="px-6 py-3 font-semibold">{o.job_number}</td>
    <td className="px-6 py-3 text-[#33424f]">{o.description}</td>
    <td className="px-6 py-3">
      <span className={`text-xs font-semibold uppercase tracking-wider ${o.active ? "text-[#2d5e1f]" : "text-[#50493b]"}`}>
        {o.active ? "Active" : "Archived"}
      </span>
    </td>
    <td className="px-6 py-3 text-right" onDoubleClick={(e) => e.stopPropagation()}>
      <JobReportMenu order={o} downloadJobReport={downloadJobReport} />
      <button
        data-testid={`download-job-csv-${o.id}`}
        onClick={(e) => { e.stopPropagation(); downloadJobReport(o.job_number, "csv"); }}
        title="Download job CSV export"
        className="hidden md:inline-flex p-1.5 hover:bg-[#e6f3ff] text-[#39678f] ml-1"
      >
        <FileTextIcon className="w-4 h-4" />
      </button>
      {canWrite && (
        <button
          data-testid={`edit-order-${o.id}`}
          onClick={() => openEdit(o)}
          className="p-1.5 hover:bg-[#e6e0db] text-[#33424f] ml-1"
        >
          <Pencil className="w-4 h-4" />
        </button>
      )}
      {canDelete && (
        <button
          data-testid={`delete-order-${o.id}`}
          onClick={() => onDelete(o)}
          className="p-1.5 hover:bg-[#fbe4ea] text-[#b30035] ml-1"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      )}
    </td>
  </tr>
);
